import { useNotification } from 'hooks';

const Notification = ({ children }) => {
  useNotification();
  return children;
};

export default Notification;
